import { ModalFooter, Stack, StackProps } from "@chakra-ui/react";
import React from "react";

/**
 * Standard modal footer containing elements in a stack.
 */
export function AppModalFooter({ children, ...stackProps }: StackProps) {
  return (
    <ModalFooter>
      <Stack
        direction={{ base: "column", xs: "row" }}
        justify="flex-end"
        w="full"
        {...stackProps}
      >
        {children}
      </Stack>
    </ModalFooter>
  );
}
